import React, { useState } from 'react';
import { Page, Card, Text, Box, Select, InlineStack, Toast } from '@shopify/polaris';
import { GlobeIcon } from '@shopify/polaris-icons';
import { useI18n, ADMIN_LANGUAGES } from '../i18n';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../auth';

// 应用设置页(v1 只有语言偏好一项,对标参考应用的 Settings):
//   下拉列出 Shopify admin 支持的 13 种界面语言(语言名用本地语言原文),
//   选择后立即切换整个 admin 界面并持久化 —— 店铺维度写入 ShopSettings
//   (GET/PUT /api/settings 的 adminLocale),同时落 localStorage,本地演示
//   / 支持模拟等无店铺会话的模式也能记住选择。店铺的前台语言不受影响。
export default function Settings() {
  const { locale, setLocale, t } = useI18n();
  const { updateSettings } = useApi();
  const { getSessionToken } = useAuth();
  const [toast, setToast] = useState(null);

  const changeLanguage = (next) => {
    setLocale(next); // UI 立即切换,不等网络
    if (!getSessionToken) return; // 本地模式:只有 localStorage 可用
    updateSettings({ adminLocale: next })
      .then(() => setToast({ content: t('settings.language.updated') }))
      .catch((err) => setToast({
        content: t('settings.language.saveFailed', { message: err.message }),
        tone: 'critical'
      }));
  };

  return (
    <Page
      title={t('settings.title')}
    >
      <div style={{ maxWidth: '720px', margin: '0 auto' }}>
        <Card>
          <Box padding="400">
            <InlineStack align="space-between" blockAlign="center">
              <Text variant="headingSm" as="h2">{t('settings.language.title')}</Text>
            </InlineStack>
            <Box paddingBlockStart="100">
              <Text variant="bodySm" as="p" tone="subdued">
                {t('settings.language.help')}
              </Text>
            </Box>
            <Box paddingBlockStart="300">
              <Select
                label={t('settings.language.label')}
                labelInline
                options={ADMIN_LANGUAGES.map(l => ({
                  label: l.label,
                  value: l.value,
                  // 选项级 prefix:合上状态下跟随选中项显示,复刻参考应用
                  // 下拉框里的地球图标(下拉展开时不显示)。
                  prefix: <GlobeIcon />
                }))}
                value={locale}
                onChange={changeLanguage}
              />
            </Box>
          </Box>
        </Card>
      </div>

      {toast && (
        <Toast
          content={toast.content}
          tone={toast.tone}
          onDismiss={() => setToast(null)}
          duration={4000}
        />
      )}
    </Page>
  );
}
